import React from "react";
import {ReservationWhiteListApp} from "../Requested/Functionality/ReservationWhiteListApp";
import UserWhiteListCards from "./UserWhiteListCards";
import DeleteModal from "../../../Modals/DeleteModal";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: FullStack - IBL
 * @Email: kpozos@ibl.mx
 */
const ReservationWhiteList = () => {

    const {
        t,
        searchElement,
        setSearchElement,
        results,
        setResults,
        option,
        rowsPerPage,
        setBodyForExport,
        setSimpleSearch,
        setSearch,
        selectedList,
        setSelectedList,
        pagination,
        getData,
        deleteModal,
        setDeleteModal,
        getActionsButtons,
        handleDelete,
        whiteListRef
    } = ReservationWhiteListApp();

    return (
        <div className="d-flex flex-column h-100 min-h-0">
            <div className="flex-grow-1 min-h-0">
                <UserWhiteListCards
                    t={t}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    results={results}
                    setResults={setResults}
                    option={option}
                    rowsPerPage={rowsPerPage}
                    setBodyForExport={setBodyForExport}
                    setSimpleSearch={setSimpleSearch}
                    setSearch={setSearch}
                    whiteListRef={whiteListRef}
                    getData={getData}
                    getActionsButtons={getActionsButtons}
                />
            </div>

            <div className="flex-shrink-0">
                {pagination()}
            </div>
            <DeleteModal
                show={deleteModal}
                onHide={() => {
                    setDeleteModal(false);
                }}
                data={selectedList}
                onClickFn={() => {
                    handleDelete();
                }}
                title_modal={"delete_records"}
                element_modal={"records"}
                isReset={() => setSelectedList([])}
            />
        </div>
    );
};

export default ReservationWhiteList;
